













































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Languague from "@/models/language/language.model";
@Component
export default class LanguagueAdd extends GenericAdd<Languague> {
  public nueva: string;
  public text: string;
  constructor() {
    super();
    this.controller = "Languages";
    this.model = new Languague();
    this.nueva = "";
    this.text = "";
  }

  public validarCodigo(event: any) {
    if (event.keyCode === 32) {
      event.preventDefault();
    }
  }

  public convertirAMinuscula(event: any) {
    this.model.key = event.target.value.toLowerCase();
  }
}
